import experiences from "../componenets/experience/experiences";
import projects from "../componenets/projects/projects";

const skillCategories = {
  Languages: ["Python", "Java", "JavaScript", "TypeScript", "C#", "HTML/CSS"],
  Frameworks: ["React", "Angular", "Vue.js", "Next.js", "Spring Boot Maven", "ASP .NET Core", "Express", "FastAPI"],
  Data: ["MySQL", "PostgreSQL", "AWS S3"],
  Cloud: ["AWS Services", "Docker", "GCP Places API"],
  AI: ["OpenAI API", "Claude"],
};

// Muted, cohesive tones — cool blues/grays
export const categoryColors = {
  Languages: "rgba(140, 170, 220, 0.85)",
  Frameworks: "rgba(140, 170, 220, 0.85)",
  Data: "rgba(140, 170, 220, 0.85)",
  Cloud: "rgba(140, 170, 220, 0.85)",
  AI: "rgba(140, 170, 220, 0.85)",
  Other: "rgba(140, 170, 220, 0.85)",
};

// Build reverse lookup: skill -> category
const skillToCategory = {};
Object.entries(skillCategories).forEach(([category, skills]) => {
  skills.forEach((skill) => {
    skillToCategory[skill] = category;
  });
});

export const getSkillColor = (skill) => {
  const category = skillToCategory[skill] || "Other";
  return categoryColors[category];
};

const getGroupedSkills = () => {
  const allSkills = new Set();

  experiences.forEach((exp) => {
    exp.technologies.split(", ").forEach((tech) => allSkills.add(tech.trim()));
  });

  projects.forEach((proj) => {
    proj.tech.split(", ").forEach((tech) => allSkills.add(tech.trim()));
  });

  const grouped = {};
  const categorized = new Set();

  Object.entries(skillCategories).forEach(([category, skills]) => {
    const matching = skills.filter((s) => allSkills.has(s));
    if (matching.length > 0) {
      grouped[category] = matching;
      matching.forEach((s) => categorized.add(s));
    }
  });

  const uncategorized = Array.from(allSkills).filter((s) => !categorized.has(s));
  if (uncategorized.length > 0) {
    grouped["Other"] = uncategorized.sort();
  }

  return grouped;
};

export default getGroupedSkills;
